import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { Row } from 'react-flexbox-grid';
import { Link } from 'react-router-dom';
import { Translation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import SignupActions from '../../../state/actions/SignupActions';

const styles = (theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
  },
});

const theme = createTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: '#3f50b5',
      dark: '#002884',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

function RegistrationError(props) {
  const { classes, clearSignupError } = props;
  useEffect(() => clearSignupError, [clearSignupError]);
  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <Paper className={classes.root} elevation={0}>
              <Typography variant="h5" component="h3">
                {t('accountExists')}
              </Typography>
              <MuiThemeProvider theme={theme}>
                <Row around="xs">
                  <Button
                    variant="contained"
                    color="secondary"
                    type="submit"
                    component={Link}
                    to={'/reset-password'}
                    className={classes.button}
                  >
                    {t('forgotPassword')}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    component={Link}
                    to={'/login'}
                    className={classes.button}
                  >
                    {t('registedGoTologin')}
                  </Button>
                </Row>
              </MuiThemeProvider>
            </Paper>
          </div>
        );
      }}
    </Translation>
  );
}

RegistrationError.propTypes = {
  classes: PropTypes.object.isRequired,
};

const { clearSignupError } = SignupActions;
export default compose(
  connect(null, { clearSignupError }),
  withStyles(styles)
)(RegistrationError);



// WEBPACK FOOTER //
// ./src/view/scenes/Registration/RegistrationError.js